define([
    "dojo/_base/declare",
    "csi/comm/PostRequest",
    "csi/gallery/Widget"
], function(declare,PostRequest,Gallery) {

    return declare(Gallery, {

        onActionSwitchLicense: function(ac) {
            var value = /LicenseSwitch(.+)/.exec(ac.m_action.m_id)[1];
            new PostRequest("LicenseManager", "SetLicenseConfig", {
                LicenseConfig: "LicenseConfig:" + value,
                Add: true
            }).post({sync:true});
        }
    });
});